import { render, staticRenderFns } from "./ford-market-share-brand.page.vue?vue&type=template&id=5ef5319c"
import script from "./ford-market-share-brand.page.vue?vue&type=script&lang=ts"
export * from "./ford-market-share-brand.page.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports